import { put } from "redux-saga/effects";
import { serverRequest } from "../../actions";

export function* collect3(action) {
  var payload = {
    action: "portal/collect",
    strategy: action.strategy,
    props: action.props,
    source: action.source,
    session: action.session,
    formDataId: action.formDataId,
    authId: action.authId,
    isSignature: action.isSignature,
  };
  yield put(serverRequest(payload));
}

export default collect3;
